import { ECGInterpreter } from './ecgInterpreter';
import { Connectivity, ECGManager } from './ecgManager';
import { ECGProxyClient } from './ecgProxyClient';

const ECGWecardio = {
  ECGManager,
  Connectivity,
  ECGProxyClient,
  ECGInterpreter,
};

export default ECGWecardio;
